import { attachmentActionTypes } from '../actions/attachmentActions';

const AttachmentReducers = (state = { }, action) => {
  switch (action.type) {
  case attachmentActionTypes.GET_ATTACHMENT_BY_ID.LOADING: {
    const { getAttachmentByIdLoading } = action;
    return {
      ...state,
      getAttachmentByIdLoading,
    };
  }
  case attachmentActionTypes.GET_ATTACHMENT_BY_ID.SUCCESS: {
    const { selectedAttachment } = action;
    return {
      ...state,
      selectedAttachment: selectedAttachment?.data,
    };
  }
  case attachmentActionTypes.CREATE_ATTACHMENT.LOADING: {
    const { createAttachmentLoading } = action;
    return {
      ...state,
      createAttachmentLoading,
    };
  }
  case attachmentActionTypes.UPDATE_ATTACHMENT.LOADING: {
    const { updateAttachmentLoading } = action;
    return {
      ...state,
      updateAttachmentLoading,
    };
  }

  case attachmentActionTypes.DELETE_ATTACHMENT.LOADING: {
    const { deleteAttachmentLoading } = action;
    return {
      ...state,
      deleteAttachmentLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default AttachmentReducers;
